import { jsx as e, jsxs as d } from "react/jsx-runtime";
import { useState as E, useEffect as O, Fragment as S } from "react";
import T from "./index10.js";
import { IconBorderRadiusIndependent as u, IconCircle as h, Icon11Square as s, IconPortrait as f, IconLandscape as L, IconUltraWide as g } from "@bynder/icons";
import { useTranslate as x, Translate as p } from "@bynder/localization";
import { textStyles as D, Box as m, Flex as M, Select as c } from "@bynder/design-system";
import { Aspect as o } from "./index5.js";
const H = ({
  aspect: r,
  isLocked: C,
  onChange: R
}) => {
  const { translate: P } = x(), [n, a] = E(r), A = (t) => {
    a(t), R(t);
  }, i = {
    [o.CUSTOM]: /* @__PURE__ */ e(u, {}),
    [o.CIRCLE]: /* @__PURE__ */ e(h, {}),
    [o.SQUARE]: /* @__PURE__ */ e(s, {}),
    [o.PORTRAIT]: /* @__PURE__ */ e(f, {}),
    [o.LANDSCAPE]: /* @__PURE__ */ e(L, {}),
    [o.WIDE]: /* @__PURE__ */ e(g, {}),
    [o.COVER]: /* @__PURE__ */ e(s, {})
  }, l = Object.keys(i);
  return O(() => {
    a(r);
  }, [r]), /* @__PURE__ */ e(m, { children: /* @__PURE__ */ d(M, { direction: "column", gap: "3", children: [
    /* @__PURE__ */ e(m, { paddingTop: "3", paddingBottom: "3", children: /* @__PURE__ */ e(_, { children: /* @__PURE__ */ e(p, { id: "CROPPER_MODAL.INSPECTOR.PATH_LABEL" }) }) }),
    /* @__PURE__ */ e(
      c,
      {
        isDisabled: C,
        icon: i[n],
        label: P(
          `CROPPER_MODAL.INSPECTOR.PATH_${n.toUpperCase()}`
        ),
        onChange: (t) => {
          A(t);
        },
        value: n,
        "aria-label": "Path",
        children: l.map((t, I) => /* @__PURE__ */ d(S, { children: [
          /* @__PURE__ */ e(c.Item, { value: t, icon: i[t], children: /* @__PURE__ */ e(
            p,
            {
              id: `CROPPER_MODAL.INSPECTOR.PATH_${t.toUpperCase()}`
            }
          ) }),
          I === 0 && l.length > 1 && /* @__PURE__ */ e(c.Divider, {})
        ] }, t))
      }
    )
  ] }) });
}, _ = T.div`
  ${D.uiTextM}
`;
export {
  H as AspectRatioControl
};
